import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, EditableDBItemV3, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { generateUUID, MUSTNeverHappenException } from '@nu-art/ts-common';
import './EditorWrapper_Accounts.scss';
import { Component_UserPermissions } from './Component_UserPermissions.js';
import { Component_ManagerSubHeader } from '@app/hcs-frontend';
import { ModuleFE_PermissionUser } from '@nu-art/permissions-frontend';
import { ModuleFE_User } from '@app/org-frontend';
import { Dialog_GenerateToken } from '../dialogs/generate-token/Dialog_GenerateToken.js';
export class EditorWrapper_Accounts extends ComponentSync {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        const user = ModuleFE_User.cache.unique(nextProps.account._id);
        if (!user)
            throw new MUSTNeverHappenException(`Could not get user for id ${nextProps.account._id}`);
        state.user = new EditableDBItemV3(user, ModuleFE_User);
        const permissionUser = ModuleFE_PermissionUser.cache.unique(nextProps.account._id);
        if (!permissionUser)
            throw new MUSTNeverHappenException(`Could not get permission user for id ${nextProps.account._id}`);
        // Need to make sure to create new editable instance only when it's needed
        if ((nextProps.account._id !== state?.account?._id) || !state.permissionUser)
            state.permissionUser = this.getEditablePermissionUser(permissionUser);
        state.account = nextProps.account;
        state.isPreview = nextProps.isPreview;
        return state;
    }
    // ######################## Logic ########################
    getEditablePermissionUser(permissionUser) {
        return new EditableDBItemV3(permissionUser, ModuleFE_PermissionUser).setAutoSave(true).setOnChanged(async (editable) => this.reDeriveState({ permissionUser: editable }));
    }
    save = async () => {
        await this.state.user.save();
        await this.state.permissionUser.save();
        this.forceUpdate();
    };
    getHeaderButtons = () => {
        if (!this.state.account)
            return [];
        const buttons = [
            _jsx(Button, { onClick: this.save, children: "Save" }, generateUUID()),
        ];
        if (this.state.account?.type === 'service')
            buttons.push(_jsx(Button, { onClick: () => Dialog_GenerateToken.show(this.state.account?._id), children: "GENERATE TOKEN" }, generateUUID()));
        return buttons;
    };
    // ######################## Render ########################
    renderHeader = () => {
        if (!this.state.isPreview)
            return _jsx(Component_ManagerSubHeader, { buttons: [] });
        return _jsx(Component_ManagerSubHeader, { buttons: this.getHeaderButtons() });
    };
    renderAccountDetails = () => {
        if (!this.state.account)
            return _jsx(_Fragment, {});
        return _jsxs(LL_H_C, { className: 'account-details', children: [_jsx("div", { children: this.state.account.email }), _jsxs("div", { children: ["(", this.state.account.type, ")"] })] });
    };
    renderBody = () => {
        return _jsxs(LL_V_L, { className: 'user-viewer__body', children: [this.renderAccountDetails(), _jsx(Component_UserPermissions, { user: this.state.user, editable: this.state.permissionUser })] });
    };
    render() {
        return _jsxs(LL_V_L, { className: 'user-viewer', children: [this.renderHeader(), this.renderBody()] });
    }
}
